<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->

<!-- Wrapper -->
<div class="flex-col flex-auto items-center w-full min-w-0 dark:bg-card">
    <!-- Header -->
    <div class="bg-white mt-1 sticky top-0 flex flex-col flex-0 justify-center w-full overflow-hidden z-49">
        <!-- Top bar -->
        <div class="relative dark justify-center w-full bg-primary">
            <div class="flex items-center w-full min-h-[48px] sm:min-h-[60px] md:min-h-[72px] justify-between">
                <ng-container>
                    <!-- Left spacer. Below md the home screen Login button sits here instead, so it
                         does not share the right hand side with the WhatsApp button and shove the
                         logo off centre. -->
                    <div class="flex-1 flex flex-row items-center justify-start pl-4">
                        <ng-container *ngIf="isScreenSmall" [ngTemplateOutlet]="loginButton"></ng-container>
                    </div>
                    <!-- Logo (centered) -->
                    <div class="flex flex-row items-center justify-center">
                        <img [routerLink]="['/']" class="w-auto h-10 hover:cursor-pointer" src="assets/images/logo/logo.png" alt="Logo image" loading="lazy">
                    </div>
                    <!-- Right side (Login from md up, WhatsApp on every breakpoint) -->
                    <div class="flex-1 flex flex-row items-center justify-end gap-4 pr-4">
                        <ng-container *ngIf="!isScreenSmall" [ngTemplateOutlet]="loginButton"></ng-container>
                        <app-whatsapp-button></app-whatsapp-button>
                    </div>
                </ng-container>

                <!-- Rendered into whichever side the breakpoint calls for -->
                <ng-template #loginButton>
                    <button *ngIf="!loggedIn && isHomeScreen()" (click)="signIn()" class="rounded-full flex flex-row border-2 border-accent py-1 px-2 items-center justify-center gap-1 hover:cursor-pointer">
                        <span class="text-white text-md font-medium p-1 ">Login</span>
                        <div class="flex items-center justify-center">
                            <mat-icon
                                class="text-accent icon-size-5 !w-3 !h-3"
                                svgIcon="heroicons_outline:user" />
                        </div>
                    </button>
                </ng-template>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="w-full" [ngClass]="loggedIn ? 'pb-10' : 'pb-0'">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Tabs -->
    <div *ngIf="!shouldHideBottomNav()" class="fixed bottom-0 left-0 right-0 z-10 w-full bg-primary text-white border-t-2 border-secondary">
        <div class="flex justify-between items-center flex-row py-2 px-2 md:px-8 ">
            <!-- Dashboard Tab -->
            <div class="flex flex-col hover:cursor-pointer" (click)="menuItemClick('dashboard')">
                <mat-icon 
                    class="transition-colors duration-200 rounded-full p-1" 
                    [class.text-accent]="isActiveRoute('/dashboard')"
                    [class.text-white]="!isActiveRoute('/dashboard')"
                    svgIcon="heroicons_outline:wifi" />
            </div>
            
            <!-- Billing Tab -->
            <div class="flex flex-col hover:cursor-pointer" (click)="menuItemClick('dashboard','invoices')">
                <mat-icon 
                    class="transition-colors duration-200 rounded-full p-1" 
                    [class.text-accent]="isActiveRoute('/dashboard/invoices')"
                    [class.text-white]="!isActiveRoute('/dashboard/invoices')"
                    svgIcon="heroicons_outline:credit-card" />
            </div>
            
            <!-- Home Tab -->
            <div class="flex flex-col hover:cursor-pointer" (click)="menuItemClick('home')">
                <img src="assets/images/logo/infinifi_background.png" alt="Infinifi logo" class="w-auto h-10">
            </div>
            
            <!-- Settings Tab -->
            <div class="flex flex-col hover:cursor-pointer" (click)="menuItemClick('dashboard','settings')">
                <mat-icon 
                    class="transition-colors duration-200 rounded-full p-1" 
                    [class.text-accent]="isActiveRoute('/dashboard/settings')"
                    [class.text-white]="!isActiveRoute('/dashboard/settings')"
                    svgIcon="feather:info" />
            </div>
            
            <!-- Profile Tab -->
            <div class="flex flex-col hover:cursor-pointer">
                <mat-icon 
                    *ngIf="loggedIn" 
                    class="transition-colors duration-200 rounded-full p-1" 
                    [class.text-accent]="isActiveRoute('/dashboard/profile-settings')"
                    [class.text-white]="!isActiveRoute('/dashboard/profile-settings')"
                    (click)="menuItemClick('dashboard','profile-settings')"
                    svgIcon="heroicons_outline:user" />
                <mat-icon 
                    *ngIf="!loggedIn" 
                    class="transition-colors duration-200 rounded-full p-1 text-white" 
                    (click)="signIn()" 
                    svgIcon="heroicons_outline:user" />
            </div>
            <!-- <div class="flex flex-col hover:cursor-pointer">
                <mat-icon 
                    *ngIf="loggedIn" 
                    class="transition-colors duration-200 rounded-full p-1" 
                    [class.text-accent]="isActiveRoute('/dashboard/profile-settings')"
                    [matMenuTriggerFor]="accountMenu" 
                    svgIcon="heroicons_outline:user" />
                <mat-icon 
                    *ngIf="!loggedIn" 
                    class="transition-colors duration-200 rounded-full p-1" 
                    (click)="signIn()" 
                    svgIcon="heroicons_outline:user" />
            </div> -->
        </div>
     </div>
     <mat-menu #accountMenu="matMenu" class="pb-0 rounded-md">
        <!-- Dashboard Overview -->
        <button mat-menu-item (click)="menuItemClick('dashboard')">
            <mat-icon class="text-secondary mr-2">dashboard</mat-icon>
            <p class="font-bold">Dashboard</p>
        </button>
        
        <mat-divider></mat-divider>
        
        <!-- Account Management -->
        <div class="px-4 py-2 text-xs font-bold text-white/70 uppercase tracking-wide">Account</div>
        <button mat-menu-item (click)="menuItemClick('dashboard','profile-settings')">
            <mat-icon class="text-secondary mr-2">account_box</mat-icon>
            <p class="font-bold">My Profile</p>
        </button>
        <button mat-menu-item (click)="menuItemClick('dashboard','profile#rica')">
            <mat-icon class="text-secondary mr-2">attach_file</mat-icon>
            <p class="font-bold">My Documents</p>
        </button>
        
        <mat-divider></mat-divider>

        <!-- Services & Support -->
        <div class="px-4 py-2 text-xs font-bold text-white/70 uppercase tracking-wide">Services</div>
        <button mat-menu-item (click)="menuItemClick('dashboard','services')">
            <mat-icon class="text-secondary mr-2">wifi</mat-icon>
            <p class="font-bold">Services</p>
        </button>

        <button mat-menu-item (click)="menuItemClick('dashboard','orders')">
            <mat-icon class="text-secondary mr-2">shopping_cart</mat-icon>
            <p class="font-bold">Orders</p>
        </button>
        

        <button mat-menu-item (click)="menuItemClick('dashboard','requests')">
            <mat-icon class="text-secondary mr-2">contact_support</mat-icon>
            <p class="font-bold">Tickets</p>
        </button>
        
        <mat-divider></mat-divider>
        
        <!-- Billing & Payments -->
        <div class="px-4 py-2 text-xs font-bold text-white/70 uppercase tracking-wide">Billing</div>
        <button mat-menu-item (click)="menuItemClick('dashboard','invoices')">
            <mat-icon class="text-secondary mr-2">credit_card</mat-icon>
            <p class="font-bold">Billing & Statements</p>
        </button>
        <button mat-menu-item (click)="menuItemClick('balances')">
            <mat-icon class="text-secondary mr-2">payments</mat-icon>
            <p class="font-bold">Pay Now</p>
        </button>
        
        <mat-divider></mat-divider>
        
        <!-- Tools -->
        <div class="px-4 py-2 text-xs font-bold text-white/70 uppercase tracking-wide">Tools</div>

        <button mat-menu-item (click)="goToNetworkStatus()">
            <mat-icon class="text-secondary mr-2">wifi</mat-icon>
            <p class="font-bold">Network Status</p>
        </button>
        <button mat-menu-item (click)="goToSpeedTest()">
            <mat-icon class="text-secondary mr-2">network_check</mat-icon>
            <p class="font-bold">Speed Test</p>
        </button>
        <button mat-menu-item (click)="goToHelp()">
            <mat-icon class="text-secondary mr-2">help</mat-icon>
            <p class="font-bold">Help / Knowledgebase</p>
        </button>
        <button mat-menu-item (click)="goToContactUs()">
            <mat-icon class="text-secondary mr-2">phone</mat-icon>
            <p class="font-bold">Contact Us</p>
        </button>
        <button mat-menu-item (click)="menuItemClick('dashboard','settings')">
            <mat-icon class="text-secondary mr-2">settings</mat-icon>
            <p class="font-bold">Settings</p>
        </button>

        
        <mat-divider></mat-divider>
        
        <!-- Account Actions -->
        <button mat-menu-item (click)="signOut()" class="text-red-600">
            <mat-icon class="text-red-600 mr-2">logout</mat-icon>
            <p class="font-bold">Logout</p>
        </button>
    </mat-menu>
</div>
